import { CHILD_BENEFIT_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaBigDecimal, schemaId } from '../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#kind

	{
		"gehoertZuAntragsteller": Antragstellerzuordnung,
		"kindergeldFuer": "ERSTES_ODER_ZWEITES_KIND" | "DRITTES_KIND" | "AB_VIERTEM_KIND",
		"name": String,
		"unterhaltseinnahmenMonatlich": schemaBigDecimal
	}

*/

export const schemaEuropaceKind = z.object({
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    id: schemaId,
    kindergeldFuer: z.optional(z.nativeEnum(CHILD_BENEFIT_TYPES)),
    name: z.optional(z.string()),
    unterhaltseinnahmenMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceKind = z.infer<typeof schemaEuropaceKind>;
